import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <div id="Youtube_thumbnails" className="text-center">
      <div className="container">
        <div className="section-title">
          
          
          <br></br><br></br>
          <h1>Motogp Thumbnail</h1>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-3 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    
  );
};

